import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { Select, FormControl, MenuItem } from '@mui/material'
import TextField from '@mui/material/TextField';

import Button from '@mui/material/Button';

import MuiDialogAlert from '../components/MuiDialogAlert';

import LoadingOverlay from 'react-loading-overlay';

import { gramsToKg, epochToDate, epochToTime, todayEpochStart, todayEpochEnd, getTodayDate } from '../components/Functions'

const axios = require('axios').default;

var timezone_offset = 8 * 60 * 60
var defaultDate = getTodayDate();

const columns = [
  { field: 'date', headerName: 'Date' },
  { field: 'time', headerName: 'Time' },
  { field: 'room_id', headerName: 'Room ID', width: 200 },
  { field: 'weight_01', headerName: 'General Waste (g)', width: 150 },
  { field: 'weight_02', headerName: 'Disposables (g)', width: 150 },
  { field: 'weight_03', headerName: 'Plastic (g)', width: 120 },
  { field: 'weight_04', headerName: 'Metal (g)', width: 120 },
  { field: 'weight_05', headerName: 'Paper (g)', width: 120 }
]


function StationReport() {

  const [loadingActive, setLoadingActive] = useState(false);

  const [modalBody, setModalBody] = useState("Update Successful");
  const [showModal, setShowModal] = useState(false);
  const [modalHeader, setModalHeader] = useState("");

  const [stationList, setStationList] = useState([]);
  const [stationIdDisplay, setStationIdDisplay] = useState("");
    
  const [showDataDiv, setShowDataDiv] = useState("hidden")
  const [stationData, setStationData] = useState({})
  const [transData, setTransData] = useState([]);
  
  const [selectedStation, setSelectedStation] = useState("");
  const [fromDateValue, setFromDateValue] = useState(todayEpochStart());
  const [toDateValue, setToDateValue] = useState(todayEpochEnd());

  const handleClose = () => setShowModal(false);
  let navigate = useNavigate();

  // Load the list of available stations into the Select Menu
  useEffect(() => {
    let url = process.env.REACT_APP_API_SERVER + "/load_parameters";
    setLoadingActive(true);

    axios.post(url, {
      "api_user": JSON.parse(localStorage.getItem('user')),
      "parameters": "StationReport"
    })
      .then(function (response) {

        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }

        let data = response.data;

        setStationList(
          data.map((d) =>{
            let tmp_json = {}
            tmp_json.id = d.station_id
            tmp_json.description = d.description
            return( tmp_json )
          }
        ))

        setSelectedStation(data[0].station_id)
        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalHeader("Error loading Stations")
        setModalBody(error)
        setShowModal(true)
      });  
  }, [])
  


  function updateForm(e) {
    let id = e.target.id;
    let name = e.target.name;
    let val = e.target.value;

    if (name === "station_id") {
      setSelectedStation(val)
    }

    if (id === "from_date") {
      let tmp = (e.target.valueAsNumber / 1000) - timezone_offset
      setFromDateValue(tmp)
    }

    if (id === "to_date") {
      let tmp = (e.target.valueAsNumber / 1000) - timezone_offset + (24 * 60 * 60) - 1
      setToDateValue(tmp)
    }

  }

  function genReport(){

    let url = process.env.REACT_APP_API_SERVER + "/gen_report";
    setLoadingActive(true);

    axios.post(url, {
      "api_user": JSON.parse(localStorage.getItem('user')),
      "parameters": "StationReport",
      "station_id" : selectedStation,
      "from_date" : fromDateValue,
      "to_date" : toDateValue
    })
      .then(function (response) {

        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }

        let data = response.data;
      
        if (data.status === "OK") {
          setStationData(data.station_data[0])

          let tmp_array = []

          data.trans_data.map((trans) => {
            let tmp = {};
            tmp.id = trans.id
            tmp.room_id = trans.room_id
            tmp.date = epochToDate(trans.epoch)
            tmp.time = epochToTime(trans.epoch)
            tmp.weight_01 = trans.weight_01
            tmp.weight_02 = trans.weight_02
            tmp.weight_03 = trans.weight_03
            tmp.weight_04 = trans.weight_04
            tmp.weight_05 = trans.weight_05

            tmp_array.push(tmp);
          } )
          setStationIdDisplay(data.station_description[0].description)
          setTransData(tmp_array)
          setShowDataDiv("")
        } else {
          // Show error msg
          setModalHeader("Error")
          setModalBody("Unable to generate report")
          setShowModal(true)        
        }


        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalHeader("Error")
        setModalBody(error)
        setShowModal(true)        
      });  

  }

  return (
    <div align="left" style={{ height: "100%" }}>
      <LoadingOverlay
        active={loadingActive}
        spinner
        text="Loading"
        className="spinner_div"
      >
        <div className="form_area">
          <div>
              <table>
                <tbody>
                  <tr>
                    <td className='form-labels'>Station ID</td>
                    <td className='form-labels'>Start Date</td>
                    <td className='form-labels'>End Date</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style={{paddingRight: "15px"}}>

                      <FormControl fullWidth>
                        <Select
                          id="station_id"
                          name="station_id"
                          variant="outlined"
                          value={selectedStation}
                          onChange={updateForm}
                          sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            ' & .MuiSelect-select': { fontSize: 14 }
                          }}
                          style={{ width: "200px" }}
                        >
                          {
                            stationList.map((station) => {
                              return <MenuItem key={station.id} value={station.id}>
                                {station.description}
                              </MenuItem>
                            })
                          }
                        </Select>
                      </FormControl>


                    </td>
                    <td style={{ paddingRight: "15px" }}>
                      <div>

                        <TextField
                          id="from_date"
                          type="date"
                          defaultValue={defaultDate}
                          onChange={updateForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            '& .MuiInputBase-input': { fontSize: 14 }
                          }}
                        />

                      </div>
                    </td>
                    <td style={{ paddingRight: "15px" }}>

                      <TextField
                        id="to_date"
                        type="date"
                        defaultValue={defaultDate}
                        onChange={updateForm}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        variant="outlined"
                        sx={{
                          '& legend': { display: 'none' },
                          '& fieldset': { top: 0 },
                          '& .MuiInputBase-input': { fontSize: 14 }
                        }}
                      />



                    </td>
                    <td style={{ paddingRight: "15px" }}>

                      <Button
                        variant="contained"
                        color="success"
                        onClick={genReport}
                        sx={{ width: 120, height: 50 }}
                      >
                        Generate
                      </Button>

                    </td>
                  </tr>
                </tbody>
              </table>
          </div>

          <div style={{ height: "30px" }}></div>


          <div className={showDataDiv}>
            <div align="center" className="station-id-display">
              {stationIdDisplay}
            </div>


            <div align="center">
              <table>
                <tr>
                  <td align="center" className="station_weight_header" width="180px" style={{paddingLeft:"15px", paddingRight:"15px"}}>General Waste</td>
                  <td align="center" className="station_weight_header" width="180px" style={{paddingLeft:"15px", paddingRight:"15px"}}>Disposables</td>
                  <td align="center" className="station_weight_header" width="180px" style={{paddingLeft:"15px", paddingRight:"15px"}}>Plastic</td>
                  <td align="center" className="station_weight_header" width="180px" style={{paddingLeft:"15px", paddingRight:"15px"}}>Metal</td>
                  <td align="center" className="station_weight_header" width="180px" style={{paddingLeft:"15px", paddingRight:"15px"}}>Paper</td>
                </tr>
                <tr>
                  <td className="station_weight_text"> <div className="station_weight_text_box"> {gramsToKg(stationData.sum_weight_01,2)} Kg </div> </td>
                  <td className="station_weight_text"> <div className="station_weight_text_box"> {gramsToKg(stationData.sum_weight_02,2)} Kg </div> </td>
                  <td className="station_weight_text"> <div className="station_weight_text_box"> {gramsToKg(stationData.sum_weight_03,2)} Kg </div> </td>
                  <td className="station_weight_text"> <div className="station_weight_text_box"> {gramsToKg(stationData.sum_weight_04,2)} Kg </div> </td>
                  <td className="station_weight_text"> <div className="station_weight_text_box"> {gramsToKg(stationData.sum_weight_05,2)} Kg </div> </td>
                </tr>
              </table>
            </div>
            <div style={{height:"30px"}}></div>

            <div style={{ height: 700, width: '100%' }}>
              <DataGrid
                rows={transData}
                columns={columns}
                pageSize={50}
                disableVirtualization
                disableSelectionOnClick
                components={{ Toolbar: GridToolbar }}
                sx={{
                  '& .MuiTablePagination-selectLabel': { paddingTop: '15px' },
                  '& .MuiTablePagination-displayedRows': { paddingTop: '15px' },
                  '& .MuiDataGrid-cell': { fontSize: 12 },
                  '& .MuiDataGrid-columnHeader': { fontSize: 12 }
                }}              
              />
            </div>

          </div>

          <MuiDialogAlert
            showModal={showModal}
            handleClose={handleClose}
            bodyContent={modalBody}
            title={modalHeader}
            bodyClass="whitespace"
          />


        </div>
      </LoadingOverlay>
    </div>  )
}

export default StationReport